import formatMoney from '../formatMoney';
import updateQuantityButtonStates from '../updateQuantityButtonStates';

const getVariantMaxQuantity = (variant, variantMaxQuantities) => {
  const match = variantMaxQuantities.find(v => v.id === variant.id);
  return match ? match.max : null;
};

const resetQuantityForVariant = (quantityInput, maxQuantity) => {
  if (!quantityInput) return;

  if (maxQuantity === null) {
    quantityInput.removeAttribute('max');
  } else {
    quantityInput.max = maxQuantity;
  }

  quantityInput.value = '1';
};

const updateFormControls = ({
  variant,
  qty,
  variantsData,
  variantMaxQuantities,
  optionNames,
  selectedOptions,
  atcButton,
  quantitySelector,
  sellingPlanId,
  getSellingPlanPrice
}) => {
  if (!atcButton) return;

  const allOptionsSelected = variantsData.length === 1 || optionNames.every(name => selectedOptions[name]);
  const quantityInput = quantitySelector?.querySelector('[data-quantity-input]');
  const quantityControls = quantitySelector?.querySelectorAll('button, input') || [];

  if (variant && variant.available && allOptionsSelected) {
    const price = getSellingPlanPrice(variant, sellingPlanId, 'price');
    if (quantitySelector) quantitySelector.dataset.qtySelectorVariantPrice = price;
    quantityControls.forEach(control => control.removeAttribute('disabled'));
    resetQuantityForVariant(quantityInput, getVariantMaxQuantity(variant, variantMaxQuantities));
    updateQuantityButtonStates(quantitySelector);
    atcButton.disabled = false;
  } else {
    quantityControls.forEach(control => control.setAttribute('disabled', true));
    atcButton.disabled = true;
  }
};

export default updateFormControls;
